import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import SearchContainer from './components/SearchContainer';
import CourseCard from './components/CourseCard';
import EnrollmentModal from './components/EnrollmentModal';
import courseService from './services/courseService';

function App() {
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Fetch courses on component mount
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        setError(null);
        const fetchedCourses = await courseService.fetchCourses();
        setCourses(fetchedCourses);
        setFilteredCourses(fetchedCourses);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  // Handle search functionality
  useEffect(() => {
    if (searchTerm === '') {
      setFilteredCourses(courses);
    } else {
      const filtered = courseService.searchCourses(courses, searchTerm);
      setFilteredCourses(filtered);
    }
  }, [searchTerm, courses]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleViewDetails = (courseId) => {
    const course = courses.find(c => c.id === courseId);
    if (!course) return;

    const summary = courseService.stripHtml(course.summary);
    alert(`Course Details:\n\nID: ${course.id}\nName: ${course.fullname}\nCode: ${course.shortname}\nSummary: ${summary}\n\nClick "Enroll Now" to begin the enrollment process.`);
  };

  const handleEnroll = (courseId) => {
    const course = courses.find(c => c.id === courseId);
    if (!course) return;

    setSelectedCourse(course);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCourse(null);
  };

  const getStatsText = () => {
    const total = courses.length;
    const showing = filteredCourses.length;
    
    if (total === 0) return 'Loading courses...';
    
    return `📚 ${showing === total ? total : `${showing} of ${total}`} Course${total !== 1 ? 's' : ''} from Category 10`;
  };

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="container">
      <Header />
      
      <SearchContainer 
        searchTerm={searchTerm} 
        onSearchChange={handleSearchChange} 
      />
      
      {courses.length > 0 && (
        <div className="stats-bar">
          <h3>{getStatsText()}</h3>
        </div>
      )}
      
      {loading && (
        <div className="loading">
          <div>🔄 Loading available courses...</div>
        </div>
      )}
      
      {error && (
        <div className="error">
          <h3>⚠️ Error Loading Courses</h3>
          <p>{error}</p>
          <p>Please check your internet connection and try again later.</p>
          <button onClick={handleRetry} className="btn btn-primary" style={{marginTop: '10px'}}>
            🔄 Retry
          </button>
        </div>
      )}
      
      {!loading && !error && (
        <div className="courses-grid">
          {filteredCourses.length === 0 ? (
            <div style={{gridColumn: '1/-1', textAlign: 'center', padding: '50px'}}>
              <h3 style={{color: 'white'}}>📚 No courses found</h3>
              <p style={{color: 'rgba(255,255,255,0.8)'}}>No courses available at this time. Please try again later.</p>
            </div>
          ) : (
            filteredCourses.map(course => (
              <CourseCard 
                key={course.id}
                course={course}
                onViewDetails={handleViewDetails}
                onEnroll={handleEnroll}
              />
            ))
          )}
        </div>
      )}
      
      <EnrollmentModal 
        isOpen={isModalOpen}
        course={selectedCourse}
        onClose={handleCloseModal}
      />
    </div>
  );
}

export default App;
